import { FunctionComponent } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { changeModule } from "../slices/modules/thunks.js";
import { useAppDispatch } from "../store/hooks.js";
import { Language, TranslatedModule } from "../types/index.js";
import { getURL } from "../utils/utils.js";
import ColorSchemeSelection from "./ColorSchemeSelection.js";

interface Props {
  translatedModule: TranslatedModule;
  pageId: string;
}

type RouterProps = RouteComponentProps<{
  siteId: string;
  languageId: Language;
}>;

const ModuleColorSchemeSelection: FunctionComponent<Props & RouterProps> = ({
  pageId,
  translatedModule: { id: moduleId, colorSchemeId, parentId },
  match: {
    params: { siteId, languageId },
  },
  history,
}) => {
  const dispatch = useAppDispatch();

  // Nested modules can't set their own color scheme
  if (parentId) return null;

  return (
    <ColorSchemeSelection
      siteId={siteId}
      activeId={colorSchemeId}
      onEdit={(id) => {
        history.push(
          getURL(
            siteId,
            "pages",
            pageId,
            languageId,
            "modules",
            moduleId,
            "design",
            "color-schemes",
            id,
          ),
        );
      }}
      onSelection={(id) =>
        dispatch(changeModule(siteId, moduleId, { colorSchemeId: id }))
      }
      onSetDefault={() =>
        dispatch(changeModule(siteId, moduleId, { colorSchemeId: null }))
      }
    />
  );
};

export default withRouter(ModuleColorSchemeSelection);
